<template>
  <div class="user-settings">
    <div class="title">グループ化切り替え</div>
    <div class="contents">
      <div class="content">
        <div class="content-title">ONにすることで、グループ化が有効になります</div>
        <div class="content-obj">
          <div class="switchArea">
            <input
              id="switch1"
              v-model="isRelations"
              type="checkbox"
              @change="toggleIsRelation">
            <label for="switch1" />
            <div id="swImg" />
          </div>
        </div>
        <div
          v-if="isImportError && isRelations"
          class="announce">
          エラーが発生しています。
          <ul>
            <li v-if="isGroupsError">グループが0件です</li>
            <li v-if="isRelationsError">メンバーが0件です</li>
            <li v-if="isRootsError">root配下のグループが0件です</li>
            <li v-if="isParentsError">メンバーに存在しない親IDが指定されています</li>
            <li v-if="isChildrenError">メンバーに存在しない子IDが指定されています</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="title">① エクスポート</div>
    <div class="contents">
      <div class="content">
        <div class="content-title">ユーザー</div>
        <div class="content-obj">
          <span
            class="export-btn"
            @click="exportUsers">エクスポート</span>
        </div>
      </div>
      <div
        v-if="isRelations"
        class="content">
        <div class="content-title">グループ</div>
        <div class="content-obj">
          <span
            class="export-btn"
            @click="exportGroups">エクスポート</span>
        </div>
      </div>
      <div
        v-if="isRelations"
        class="content">
        <div class="content-title">メンバー</div>
        <div class="content-obj">
          <span
            class="export-btn"
            @click="exportRelations">エクスポート</span>
        </div>
      </div>
    </div>
    <div class="title">② インポート</div>
    <div class="content">
      <div class="content-title">ユーザー</div>
      <div class="content-obj">
        <label for="users-import">
          <span class="import-btn">インポート</span><br>
          <input
            id="users-import"
            ref="usersImport"
            type="file"
            accept=".csv"
            @input="importUsers">
        </label>
      </div>
    </div>
    <div
      v-if="isRelations"
      class="content">
      <div class="content-title">グループ</div>
      <div class="content-obj">
        <label for="groups-import">
          <span class="import-btn">インポート</span><br>
          <input
            id="groups-import"
            ref="groupsImport"
            type="file"
            accept=".csv"
            @input="importGroups">
        </label>
      </div>
    </div>
    <div
      v-if="isRelations"
      class="content">
      <div class="content-title">メンバー</div>
      <div class="content-obj">
        <label for="relations-import">
          <span class="import-btn">インポート</span><br>
          <input
            id="relations-import"
            ref="relationsImport"
            type="file"
            accept=".csv"
            @input="importRelations">
        </label>
      </div>
    </div>
    <div
      v-if="isImported"
      class="overlay"
      @mousedown="close">
      <div
        class="panel"
        @mousedown.stop>
        <div class="header">
          <div class="menu">
            <span
              title="閉じる"
              class="menu-label"
              @click="close">
              <i class="material-icons">close</i>
              <span class="menu-label">閉じる</span>
            </span>
          </div>
        </div>
        <span v-if="errors.length !== 0">
          <div class="item">
            <span class="item-content number">No.</span>
            <span class="item-content error-index">行数</span>
            <span class="item-content error-contents">エラー内容</span>
          </div>
          <div class="import-data">
            <span
              v-for="(error, index) in errors"
              :key="index"
              class="data">
              <span class="data-content number">{{ index + 1 }}</span>
              <span class="data-content error-index">{{ error.index }}</span>
              <span class="data-content error-contents">{{ error.text }}</span>
            </span>
          </div>
          <div class="footer" />
        </span>
        <span v-else-if="users.length !== 0">
          <div class="item">
            <span class="item-content number">No.</span>
            <span class="item-content status">状態</span>
            <span class="item-content id">ID</span>
            <span class="item-content mail">メールアドレス</span>
            <span class="item-content name">名前</span>
            <span class="item-content priority">並び順</span>
            <span class="item-content small">管理者</span>
            <span class="item-content small">有効</span>
            <span class="item-content small">表示</span>
            <span class="scroll" />
          </div>
          <div class="import-data">
            <span
              v-for="(user, index) in users"
              :key="index"
              :class="['data', {change: user.status !== '-'}]">
              <span class="data-content number">{{ index + 1 }}</span>
              <span class="data-content status">{{ user.status }}</span>
              <span class="data-content id">{{ user.id }}</span>
              <span class="data-content mail">{{ user.mail }}</span>
              <span class="data-content name">{{ user.name.last + user.name.first }}</span>
              <span class="data-content priority">{{ user.priority }}</span>
              <span class="data-content small">{{ user.isAdmin }}</span>
              <span class="data-content small">{{ user.isActive }}</span>
              <span class="data-content small">{{ user.isDisplay }}</span>
            </span>
          </div>
          <div class="footer">
            <button
              v-if="!!errors"
              class="save-sort"
              @click="saveUsers"
            >保存</button>
          </div>
        </span>
        <span v-else-if="groups.length !== 0">
          <div class="item">
            <span class="item-content number">No.</span>
            <span class="item-content status">状態</span>
            <span class="item-content id">ID</span>
            <span class="item-content name">名前</span>
            <span class="item-content small">表示</span>
          </div>
          <div class="import-data">
            <span
              v-for="(group, index) in groups"
              :key="index"
              :class="['data', {change: group.status !== '-'}]">
              <span class="data-content number">{{ index + 1 }}</span>
              <span class="data-content status">{{ group.status }}</span>
              <span class="data-content id">{{ group.id }}</span>
              <span class="data-content name">{{ group.name }}</span>
              <span class="data-content small">{{ group.isDisplay }}</span>
            </span>
          </div>
          <div class="footer">
            <button
              v-if="!!errors"
              class="save-sort"
              @click="saveGroups"
            >保存</button>
          </div>
        </span>
        <span v-else-if="relations.length !== 0">
          <div class="item">
            <span class="item-content number">No.</span>
            <span class="item-content status">状態</span>
            <span class="item-content id">ID</span>
            <span class="item-content name">親名前</span>
            <span class="item-content id">子ID</span>
            <span class="item-content name">子名前</span>
            <span class="item-content priority">並び順</span>
          </div>
          <div class="import-data">
            <span
              v-for="(relation, index) in relations"
              :key="index"
              :class="['data', {change: relation.status !== '-'}]">
              <span class="data-content number">{{ index + 1 }}</span>
              <span class="data-content status">{{ relation.status }}</span>
              <span class="data-content id">{{ relation.current.id }}</span>
              <span class="data-content name">{{ relation.current.name }}</span>
              <span class="data-content id">{{ relation.child.id }}</span>
              <span class="data-content name">{{ relation.child.name }}</span>
              <span class="data-content priority">{{ relation.priority }}</span>
            </span>
          </div>
          <div class="footer">
            <button
              v-if="!!errors"
              class="save-sort"
              @click="saveRelations"
            >保存</button>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from '@/plugins/firestore'
import csv from '@/utils/csv'
import sw from '@/utils/sweetAlert'
import config from '@/utils/const'

export default {
  data () {
    return {
      /**
       * ダイアログで表示するエラー項目
       * @type {Array}
       */
      errors: [],
      /**
       * DBに保存するユーザー
       * @type {Array}
       */
      users: [],
      /**
       * DBに保存するグループ
       * @type {Array}
       */
      groups: [],
      /**
       * DBに保存するリレーション(メンバー)
       * @type {Array}
       */
      relations: [],
      /**
       * DBから取得したユーザー
       * @type {Array}
       */
      savedUsers: [],
      /**
       * DBから取得したグループ
       * @type {Array}
       */
      savedGroups: [],
      /**
       * DBから取得したリレーション(メンバー)
       * @type {Array}
       */
      savedRelations:[],
      /**
       * インポートが成功したか判別するフラグ
       * @type {Boolean}
       */
      isImported: false,
      /**
       * グループ化が有効か判別するフラグ
       * @type {Boolean}
       */
      isRelations: false,
      /**
       * インポートされているデータ(ユーザー、グループ、リレーション)の状態が正しいかを判別する
       * @type {Boolean}
       */
      isImportError: false,
      /**
       * グループが0件かを判別する
       * @type {Boolean}
       */
      isGroupsError: false,
      /**
       * リレーションが0件かを判別する
       * @type {Boolean}
       */
      isRelationsError: false,
      /**
       * root配下のグループが0件かを判別する
       * @type {Boolean}
       */
      isRootsError: false,
      /**
       * リレーションに存在しない親IDが指定されているかを判別する
       * @type {Boolean}
       */
      isParentsError: false,
      /**
       * リレーションに存在しない子IDが指定されているかを判別する
       * @type {Boolean}
       */
      isChildrenError: false
    }
  },
  computed: {
    /**
     * firestoreから「Users」を取得する処理を短縮する目的のプロパティ
     * @returns {Object} Users取得DBアクセスプロパティ
     */
    usersDB () { return db.collection(`tenants/${this.$store.state.tenant}/users`) },
    /**
     * firestoreから「Groups」を取得する処理を短縮する目的のプロパティ
     * @returns {Object} Groups取得DBアクセスプロパティ
     */
    groupsDB () { return db.collection(`tenants/${this.$store.state.tenant}/groups`) },
    /**
     * firestoreから「Relations」を取得する処理を短縮する目的のプロパティ
     * @returns {Object} Relations取得DBアクセスプロパティ
     */
    relationsDB () { return db.collection(`tenants/${this.$store.state.tenant}/relations`) },
  },
  async created () {
    // インポート中に、リロードをしたり、ブラウザを閉じようとすると警告
    window.addEventListener('beforeunload', this.confirmSave)
    // hack: 設定に必要な情報はどこかで一括して取得したい
    await db.doc('tenants/' + this.$store.state.tenant).get()
      .then((doc) => {
        this.$store.commit('setImport', doc.data().import || { run: config.import.run.none, user: '' })
        this.isRelations = doc.data().isRelations
      })
      .catch((error) => {
        sw.toastAlert('error', '取得に失敗しました')
        console.error(`エラー:${error}`)
      })

    // ログイン済み管理者ユーザーの場合
    if (this.$store.state.currentUser && this.$store.state.isSignIn && this.$store.state.currentUser.isAdmin) {
      // 前回のインポート処理を不正に中断した場合
      if (this.$store.state.import.run && this.$store.state.import.user === this.$store.state.currentUser.mail) {
        await this.$swal({
          icon: 'warning',
          html: '前回インポート処理を不正に中断しました。<br>インポート処理を終了します。',
          allowOutsideClick : false,
          allowEnterKey: false,
          confirmButtonColor: '#ff3d0c'
        }).then(() => {
          this.unlockDB()
          this.$store.commit('setImport', {run: config.import.run.none, user: ''})
        })
      }
    }

    this.validateImport()
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.confirmSave)
  },
  methods: {
    /**
     * インポートされているデータ(ユーザー、グループ、リレーション)の状態が正しいかを判別する
     */
    validateImport () {
      let promise = [
        this.usersDB.get()
          .then((query) => {
            let users = []
            query.forEach((doc) => {
              users.push({id: doc.id, ...doc.data()})
            })
            return users
          }),
        this.groupsDB.get()
          .then((query) => {
            let groups = []
            query.forEach((doc) => {
              groups.push({id: doc.id, ...doc.data()})
            })
            return groups
          }),
        this.relationsDB.get()
          .then((query) => {
            let relations = []
            query.forEach((doc) => {
              relations.push({id: doc.id, ...doc.data()})
            })
            return relations
          }),
      ]
      Promise.all(promise)
        .then((results) => {
          const users = results[0]
          const groups = results[1]
          const relations = results[2]
          this.isImportError = false
          this.isGroupsError = false
          this.isRelationsError = false
          this.isRootsError = false
          this.isParentsError = false
          this.isChildrenError = false
          this.importErrorMessage = ''
          // groups存在チェック
          if (groups.length === 0) {
            this.isImportError = true
            this.isGroupsError = true
          }
          // relations存在チェック
          if (relations.length === 0) {
            this.isImportError = true
            this.isRelationsError = true
          }
          // ROOT存在チェック
          if (!relations.some(r => r.currentId === 'root')) {
            this.isImportError = true
            this.isRootsError = true
          }
          // 親ID存在チェック
          if (relations.some(r => r.currentId !== 'root' && !groups.some(g => r.currentId === g.id))) {
            this.isImportError = true
            this.isParentsError = true
          }
          // 子ID存在チェック
          relations.forEach(r => {
            if (r.children.groups.some(r => !groups.some(g => r.id === g.id)) ||
                r.children.users.some(r => !users.some(u => r.id === u.id))) {
              this.isImportError = true
              this.isChildrenError = true
            }
          })
        })
    },
    /**
     * ダイアログを閉じる
     */
    close () {
      this.$swal({
        icon: 'warning',
        text: 'インポートしたデータを破棄してもよろしいですか？',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: '#ff3d0c'
      }).then((result) => {
        if (!result.isConfirmed) return
        this.$store.commit('setHasChanged', false)
        // インポートデータを破棄
        this.errors = []
        this.users = []
        this.groups = []
        this.relations = []
        this.isImported = false
        this.unlockDB()
      })
    },
    /**
     * グループ化の有効無効を切り替える
     */
    toggleIsRelation () {
      db.doc(`tenants/${this.$store.state.tenant}`).update({
        isRelations: this.isRelations
      }).then(() => {
        this.validateImport()
        sw.toastAlert('success', '保存しました')
      }).catch((error) => {
        sw.toastAlert('error', '保存に失敗しました')
        console.error(`エラー:${error}`)
      })
    },
    /**
     * インポートが可能かを判別する
     * @returns {String}
     */
    async canImport () {
      this.$store.commit('setHasChanged', true)
      let run = config.import.run.none
      await db.doc('tenants/' + this.$store.state.tenant).get()
        .then((doc) => {
          run = this.deleteImportInfoWhenImportIsUnavailable(doc)
          // 他のユーザーがインポート中、または自分が他の場所でインポート中の場合
          if (run !== config.import.run.none) return

          // DBをロックする
          db.doc('tenants/' + this.$store.state.tenant).update({
            import: {
              run: config.import.run.organization,
              user: this.$store.state.currentUser.mail
            }
          })
        })
      return run
    },
    /**
     * Booleanかどうかをチェックする
     * @param {String} value チェックされる文字
     * @returns {(Boolean|Null)}
     */
    parseBoolean (value) {
      switch (value) {
        case true:
        case 'true':
        case 'TRUE':
          return true;
        case false:
        case 'false':
        case 'FALSE':
          return false;
        default:
          return null;
      }
    },
    /**
     * ユーザーをCSV形式でエクスポートする
     */
    async exportUsers () {
      let csvData = ''
      const header1 = 'ユーザーID(編集不可),メールアドレス(変更不可),姓(必須),名(必須),並び順(必須),管理者(必須),有効(必須),表示(必須)\n'
      const header2 = 'uid,email,lastName,firstName,priority,isAdmin,isActive,isDisplay\n'
      await this.usersDB.orderBy('priority').get()
        .then((users) => {
          users.forEach((user) => {
            csvData +=
              `${user.id},` +
              `${csv.formatCsv(user.data().mail)},` +
              `${csv.formatCsv(user.data().name.last)},` +
              `${csv.formatCsv(user.data().name.first)},` +
              `${user.data().priority},` +
              `${user.data().isAdmin},` +
              `${user.data().isActive},` +
              `${user.data().isDisplay}\n`
          })
        })
      csv.exportCsv((header1 + header2 + csvData), 'UsersData')
    },
    /**
     * グループをCSV形式でエクスポートする
     */
    async exportGroups () {
      let csvData = ''
      const header1 = 'グループID(編集不可),グループ名(必須),表示(必須)\n'
      const header2 = 'gid,groupName,isDisplay\n'
      await this.groupsDB.get()
        .then((groups) => {
          groups.forEach((group) => {
            csvData +=
              `${group.id},` +
              `${csv.formatCsv(group.data().name)},` +
              `${group.data().isDisplay}\n`
          })
        })
      csv.exportCsv((header1 + header2 + csvData), 'GroupsData')
    },
    /**
     * リレーション(メンバー)をCSV形式でエクスポートする
     */
    async exportRelations () {
      let csvData = ''
      const header1 = '親ID(必須),子ID(必須),並び順(必須)\n'
      const header2 = 'id,childId,priority\n'
      await this.relationsDB.get()
        .then(async (relations) => {
          relations.forEach((relation) => {
            if (relation.data().currentId.toLowerCase().trim() === 'root') {
              relation.data().children.groups.forEach((group) => {
                csvData =
                  `${relation.data().currentId},` +
                  `${group.id},` +
                  `${group.priority}\n` +
                  csvData
              })
            } else {
              if (relation.data().children.groups) {
                relation.data().children.groups.forEach((group) => {
                  csvData +=
                    `${relation.data().currentId},` +
                    `${group.id},` +
                    `${group.priority}\n`
                })
              }
              if (relation.data().children.users) {
                relation.data().children.users.forEach((user) => {
                  csvData +=
                    `${relation.data().currentId},` +
                    `${user.id},` +
                    `${user.priority}\n`
                })
              }
            }
          })
        })
      csv.exportCsv((header1 + header2 + csvData), 'MembersData')
    },
    /**
     * CSV形式で記載されたユーザーの並び順をインポートし適用する
     */
    async importUsers () {
      sw.infoAlert('読み込み中...')
      if (await this.canImport() !== config.import.run.none) return
      let savedUsers = []
      let importedUsers = []
      let importUsers = await csv.importCsv(this.$refs.usersImport.files[0])
      this.$refs.usersImport.value = null
      await this.usersDB.orderBy('priority').get()
        .then((users) => {
          savedUsers = users.docs.map((user) => {
            return {
              id: user.id,
              mail: user.data().mail,
              name: {
                last: user.data().name.last,
                first: user.data().name.first
              },
              priority: user.data().priority,
              isAdmin: user.data().isAdmin,
              isActive: user.data().isActive,
              isDisplay: user.data().isDisplay
            }
          })
        })
      importUsers.forEach((user, index) => {
        // 空白行はスキップ
        if (!user[0] && !user[1] && !user[2] && !user[3] && !user[4] && !user[5] && !user[6] && !user[7]) return
        const id = user[0]
        const mail = user[1]
        const name = {
          last: user[2],
          first: user[3]
        }
        const priority = Number(user[4])
        const isAdmin = this.parseBoolean(user[5])
        const isActive = this.parseBoolean(user[6])
        const isDisplay = this.parseBoolean(user[7])
        const existsUser = savedUsers.some(u => u.id === id && u.mail === mail)
        // IDチェック
        if (id && !existsUser) {
          this.errors.push({
            index: index + 3,
            text: '新規ユーザーのID列に文字が入っている または 既存ユーザーのID・メールアドレスが編集されている'
          })
        }
        // 空白チェック
        if (user.slice(1).includes('')) {
          this.errors.push({
            index: index + 3,
            text: 'ユーザーID列以外の各項目に空白が入っている'
          })
        }
        // true, falseチェック
        if ([isAdmin, isActive, isDisplay].includes(null)) {
          this.errors.push({
            index: index + 3,
            text: '管理者、有効、表示に"true", "false"以外が入力されている'
          })
        }
        // 並び順チェック
        if (isNaN(priority)) {
          this.errors.push({
            index: index + 3,
            text: '並び順に数値以外が入力されている'
          })
        }
        // ID重複チェック
        if (importedUsers.some(u => u.id === id) && id) {
          this.errors.push({
            index: index + 3,
            text: 'IDが重複している'
          })
        }
        // 新規ユーザーのメールアドレス重複チェック
        if (importedUsers.some(u => u.mail === mail) && mail) {
          this.errors.push({
            index: index + 3,
            text: 'メールアドレスが重複している'
          })
        }
        importedUsers.push({
          id: id,
          mail: mail
        })
        if (this.errors.length !== 0) return
        // 既存ユーザー格納
        if (existsUser) {
          let status = config.status.edit
          let targetUser = savedUsers.find(u => u.id === id)
          if (targetUser.id === id &&
            targetUser.mail === mail &&
            targetUser.name.last === name.last &&
            targetUser.name.first === name.first &&
            targetUser.priority === priority &&
            targetUser.isAdmin === isAdmin &&
            targetUser.isActive === isActive &&
            targetUser.isDisplay === isDisplay)
            status = config.status.constant
          this.users.push({
            id: id,
            status: status,
            mail: mail,
            name: {
              last: name.last,
              first: name.first
            },
            priority: priority,
            isAdmin: isAdmin,
            isActive: isActive,
            isDisplay: isDisplay
          })
        }
        // 新規ユーザー格納
        else {
          this.users.push({
            status: config.status.new,
            mail: mail,
            name: {
              last: name.last,
              first: name.first
            },
            priority: priority,
            isAdmin: isAdmin,
            isActive: isActive,
            isDisplay: isDisplay
          })
        }
      })
      // ユーザーが0人でないかチェック
      if (this.users.length === 0) {
        this.errors.push({
          index: '-',
          text: 'ユーザーを0人にすることはできません'
        })
      }
      // 管理者が0人でないかチェック
      if (!this.users.some(u => u.isAdmin === true)) {
        this.errors.push({
          index: '-',
          text: '管理者を0人にすることはできません'
        })
      }
      // 削除ユーザー格納
      savedUsers.forEach((user) => {
        if (importUsers.some(u => u[0] === user.id)) return
        this.users.push({
          id: user.id,
          status: config.status.delete,
          mail: user.mail,
          name: {
            last: user.name.last,
            first: user.name.first
          },
          priority: '',
          isAdmin: user.isAdmin,
          isActive: user.isActive,
          isDisplay: user.isDisplay
        })
      })
      this.isImported = true
      sw.toastAlert('success', 'インポートしました')
    },
    /**
     * CSV形式で記載されたグループの並び順をインポートし適用する
     */
    async importGroups () {
      sw.infoAlert('読み込み中...')
      if (await this.canImport() !== config.import.run.none) return
      let savedGroups = []
      let importedGroups = []
      let importGroups = await csv.importCsv(this.$refs.groupsImport.files[0])
      this.$refs.groupsImport.value = null
      await this.groupsDB.get().then((groups) => {
        savedGroups = groups.docs.map((group) => {
          return {
            id: group.id,
            name: group.data().name,
            isDisplay: group.data().isDisplay
          }
        })
      })
      importGroups.forEach((group, index) => {
        // 空白行はスキップ
        if (!group[0] && !group[1] && !group[2]) return
        const id = group[0]
        const name = group[1]
        const isDisplay = this.parseBoolean(group[2])
        const existsGroup = savedGroups.some(u => u.id === id)
        // IDチェック
        if (id && !existsGroup){
          this.errors.push({
            index: index + 3,
            text: '新規グループのID列に文字が入っている'
          })
        }
        // 空白チェック
        if (group.slice(1).includes('')) {
          this.errors.push({
            index: index + 3,
            text: 'グループID以外の各項目に空白が入っている'
          })
        }
        // true, falseチェック
        if (isDisplay === null) {
          this.errors.push({
            index: index + 3,
            text: '表示に"true", "false"以外が入力されている'
          })
        }
        // ID重複チェック
        if (importedGroups.some(u => u.id === id) && id) {
          this.errors.push({
            index: index + 3,
            text: 'IDが重複している'
          })
        }
        importedGroups.push({
          id: id,
          name: name
        })
        if (this.errors.length !== 0) return
        // 既存グループ格納
        if (existsGroup) {
          let status = config.status.edit
          let targetGroup = savedGroups.find(g => g.id === id)
          if (targetGroup.id === id &&
            targetGroup.name === name &&
            targetGroup.isDisplay === isDisplay)
            status = config.status.constant
          this.groups.push({
            id: id,
            status: status,
            name: name,
            isDisplay: isDisplay
          })
        }
        // 新規グループ格納
        else {
          this.groups.push({
            status: config.status.new,
            name: name,
            isDisplay: isDisplay
          })
        }
      })
      // グループが0件でないかチェック
      if (this.groups.length === 0) {
        this.errors.push({
          index: '-',
          text: 'グループを0件にすることはできません'
        })
      }
      // 削除グループ格納
      savedGroups.forEach((group) => {
        if (importGroups.some(g => g[0] === group.id)) return
        this.groups.push({
          id: group.id,
          status: config.status.delete,
          name: group.name,
          isDisplay: group.isDisplay
        })
      })
      this.isImported = true
      sw.toastAlert('success', 'インポートしました')
    },
    /**
     * CSV形式で記載されたユーザーの並び順をインポートし適用する
     */
    async importRelations () {
      sw.infoAlert('読み込み中...')
      if (await this.canImport() !== config.import.run.none) return
      this.savedUsers = []
      this.savedRelations = []
      let savedGroups = []
      let importedRelations = []
      let importRelations = await csv.importCsv(this.$refs.relationsImport.files[0])
      this.$refs.relationsImport.value = null
      await this.usersDB.orderBy('priority').get()
        .then((users) => {
          users.forEach((user) => {
            this.savedUsers.push({
              id: user.id,
              name: user.data().name.last + user.data().name.first
            })
          })
        })
      await this.groupsDB.get()
        .then((groups) => {
          groups.forEach((group) => {
            savedGroups.push({
              id: group.id,
              name: group.data().name
            })
          })
        })
      await this.relationsDB.get()
        .then((relations) => {
          relations.forEach((relation) => {
            let children = relation.data().children.groups.concat(relation.data().children.users)
            children.forEach((child) => {
              const isRoot = relation.data().currentId === 'root'
              this.savedRelations.push({
                id: relation.id,
                current: isRoot ? { id: 'root', name: 'ルート' }
                                : savedGroups.find(group => group.id === relation.data().currentId),
                child: isRoot ? savedGroups.find(group => group.id === child.id)
                               : this.savedUsers.find(user => user.id === child.id),
                priority: child.priority,
                parentIds: relation.data().parentIds
              })
            })
          })
        })
      // ROOT存在チェック
      if (!importRelations.some(r => r[0].toLowerCase().trim() === 'root')) {
        this.errors.push({
          index: config.status.constant,
          text: 'rootは1つ以上必要'
        })
      }
      importRelations.forEach((relation, index) => {
        // 空白行はスキップ
        if (!relation[0] && !relation[1] && !relation[2]) return
        const currentId = relation[0]
        const childId = relation[1]
        const priority = Number(relation[2])
        const existsRelation = this.savedRelations.some(r => r.current.id === currentId && r.child.id === childId)
        // 親ID存在チェック
        if (currentId.toLowerCase() !== 'root' &&
            !this.savedUsers.some((user) => user.id === currentId) &&
            !savedGroups.some((group) => group.id === currentId)) {
          this.errors.push({
            index: index + 3,
            text: '存在しない親IDが指定されている'
          })
        }
        if (this.savedUsers.some((user) => user.id === currentId)) {
          this.errors.push({
            index: index + 3,
            text: '親IDにユーザーが指定されている'
          })
        }
        // 子ID存在チェック
        if (!this.savedUsers.some((user) => user.id === childId) &&
            !savedGroups.some(group => group.id === childId)) {
          this.errors.push({
            index: index + 3,
            text: '存在しない子IDが指定されている'
          })
        }
        // 空白チェック
        if (relation.includes('')) {
          this.errors.push({
            index: index + 3,
            text: '各項目に空白が入っている'
          })
        }
        // 並び順チェック
        if (isNaN(priority)) {
          this.errors.push({
            index: index + 3,
            text: '並び順に数値以外が入力されている'
          })
        }
        // ID重複チェック
        if (importedRelations.some(r => r.currentId === currentId && r.childId === childId)) {
          this.errors.push({
            index: index + 3,
            text: 'IDが重複している'
          })
        }
        importedRelations.push({
          currentId: currentId,
          childId: childId
        })
        if (this.errors.length !== 0) return
        // 既存リレーション(メンバー)格納
        if (existsRelation) {
          let status = config.status.edit
          const targetRelation = this.savedRelations.find(r => r.current.id === currentId && r.child.id === childId)
          if (targetRelation.priority === priority) status = config.status.constant
          this.relations.push({
            status: status,
            id: targetRelation.id,
            current: {
              id: currentId,
              name: targetRelation.current.name,
            },
            child: {
              id: childId,
              name: targetRelation.child.name,
            },
            priority: priority
          })
        }
        // 新規リレーション(メンバー)格納
        else {
          const isRoot = currentId === 'root'
          this.relations.push({
            status: config.status.new,
            // id: ,
            current: {
              id: currentId,
              name: isRoot ? '' : savedGroups.find(group => group.id === currentId).name
            },
            child: {
              id: childId,
              name: isRoot ? savedGroups.find(group => group.id === childId).name
                           : this.savedUsers.find(user => user.id === childId).name,
            },
            priority: priority
          })
        }
      })
      // リレーションが0件でないかチェック
      if (this.relations.length === 0) {
        this.errors.push({
          index: '-',
          text: 'メンバーを0件にすることはできません'
        })
      }
      // 削除リレーション(メンバー)格納
      this.savedRelations.forEach(relation => {
        if (importRelations.some(r => r[0] === relation.current.id && r[1] === relation.child.id)) return
        this.relations.push({
          status: config.status.delete,
          // id: ,
          current: {
            id: relation.current.id,
            name: relation.current.name,
          },
          child: {
            id: relation.child.id,
            name: relation.child.name,
          },
          priority: relation.priority
        })
      })
      this.isImported = true
      sw.toastAlert('success', 'インポートしました')
    },
    /**
     * インポートしたユーザー情報を保存する
     */
    async saveUsers () {
      let isConfirmed = false
      await this.$swal({
        icon: 'warning',
        text: '保存してもよろしいですか？',
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        isConfirmed = result.isConfirmed
      })
      if (!isConfirmed) return
      this.users.forEach((user) => {
        switch (user.status) {
          case config.status.new:
            this.usersDB.add({
              mail: user.mail,
              name: {
                last: user.name.last,
                first: user.name.first
              },
              priority: user.priority,
              isAdmin: user.isAdmin,
              isActive: user.isActive,
              isDisplay: user.isDisplay
            })
            break
          case config.status.edit:
            this.usersDB.doc(user.id).update({
              mail: user.mail,
              name: {
                last: user.name.last,
                first: user.name.first
              },
              priority: user.priority,
              isAdmin: user.isAdmin,
              isActive: user.isActive,
              isDisplay: user.isDisplay
            })
            break
          case config.status.delete:
            this.usersDB.doc(user.id).delete()
            break
          case config.status.constant:
            break
          default:
            console.error(`不正なstatusが読み込まれました。 => ${user.status}`)
            break
        }
      })
      this.isImported = false
      this.users = []
      this.unlockDB()
      this.validateImport()
      sw.toastAlert('success', '保存しました')
    },
    /**
     * インポートしたグループ情報を保存する
     */
    async saveGroups () {
      let isConfirmed = false
      await this.$swal({
        icon: 'warning',
        text: '保存してもよろしいですか？',
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        isConfirmed = result.isConfirmed
      })
      if (!isConfirmed) return
      this.groups.forEach((group) => {
        switch (group.status) {
          case config.status.new:
            this.groupsDB.add({
              name: group.name,
              isDisplay: group.isDisplay
            })
            break
          case config.status.edit:
            this.groupsDB.doc(group.id).update({
              name: group.name,
              isDisplay: group.isDisplay
            })
            break
          case config.status.delete:
            this.groupsDB.doc(group.id).delete()
            break
          case config.status.constant:
            break
          default:
            console.error(`不正なstatusが読み込まれました。 => ${group.status}`)
            break
        }
      })
      this.isImported = false
      this.groups = []
      this.unlockDB()
      this.$store.dispatch('getGroups')
      this.validateImport()
      sw.toastAlert('success', '保存しました')
    },
    /**
     * インポートしたリレーション(メンバー)情報を保存する
     */
    async saveRelations () {
      let isConfirmed = false
      await this.$swal({
        icon: 'warning',
        text: '保存してもよろしいですか？',
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        isConfirmed = result.isConfirmed
      })

      if (!isConfirmed) return

      // DBに格納するデータを成形
      let relations = []
      this.relations.forEach((relation) => {
        if (relation.status === config.status.delete) return

        if (!relations.some(r => r.currentId === relation.current.id)) {
          let parentIds = []
          this.relations.filter(r => r.childId === relation.current.id)
            .forEach(p => parentIds.push(p.current.id))
          relations.push({
            id: relation.id,
            currentId: relation.current.id,
            children: {
              groups: [],
              users: []
            },
            parentIds: parentIds
          })
        }
        if (this.savedUsers.some((user) => user.id === relation.child.id)) {
          relations.find(r => r.currentId === relation.current.id).children.users
            .push({
              id: relation.child.id,
              priority: relation.priority
            })
        } else {
          relations.find(r => r.currentId === relation.current.id).children.groups
            .push({
              id: relation.child.id,
              priority: relation.priority
            })
        }
      })
      // 削除されているリレーション(メンバー)をDBから削除する
      this.savedRelations.forEach(relation => {
        if (relations.some(r => r.id === relation.id) || relation.id === 'root') return
        this.relationsDB.doc(relation.id).delete()
      })
      // DBにリレーション(メンバー)情報を格納する
      relations.forEach((relation) => {
        if (relation.id) {
          this.relationsDB.doc(relation.id).update({
            currentId: relation.currentId,
            children: {
              groups: relation.children.groups,
              users: relation.children.users
            },
            parentIds: relation.parentIds
          })
        } else {
          if (relation.currentId !== 'root') {
            this.relationsDB.add({
              currentId: relation.currentId,
              children: {
                groups: relation.children.groups,
                users: relation.children.users
              },
              parentIds: relation.parentIds
            })
          } else {
            this.relationsDB.doc('root').set({
              currentId: relation.currentId,
              children: {
                groups: relation.children.groups,
                users: relation.children.users
              },
              parentIds: null
            })
          }
        }
      })
      this.isImported = false
      this.relations = []
      this.unlockDB()
      this.validateImport()
      sw.toastAlert('success', '保存しました')
    },
    /**
     * 画面遷移に対して警告を出す
     * @param {Object} event addEventListener()を発火させたときに渡される引数
     */
    confirmSave (event) {
      // インポート中の時だけ警告を出す
      if (this.$store.state.hasChanged) {
        event.preventDefault()
        // メッセージ内容はブラウザによって固定されている。
        // Chromeなら「このサイトを再読み込みしますか？行った変更が保存されない可能性があります。」と表示される
        // returnValueで設定したメッセージを表示できるのはIEだけだが、設定しないと正常にダイアログが表示されないことがある
        event.returnValue = "行った変更が保存されない可能性があります。よろしいですか？"
      }
    },
    /**
     * DBのロックを解除
     */
    unlockDB () {
      db.doc('tenants/' + this.$store.state.tenant).update({
        import: {
          run: config.import.run.none,
          user: ''
        }
      })
    },
    /**
     * インポートができない時に、インポートの情報を削除
     * @param {Object} doc firestoreから取ってきた情報
     * @returns {Enum} インポートをしている場所、インポート可能ならconfig.import.run.none(空文字)を返す
     */
    deleteImportInfoWhenImportIsUnavailable (doc) {
      let html = ''
      // 別のユーザーがインポート中の場合
      if (doc.data().import && doc.data().import.run && doc.data().import.user !== this.$store.state.currentUser.mail) {
        html = `<font size="3" color="#828282">${doc.data().import.user}</font><br>がインポート処理中のためインポートができません`
        // 別の場所でインポート中の場合
      } else if(doc.data().import && doc.data().import.run !== config.import.run.organization && doc.data().import.user === this.$store.state.currentUser.mail) {
        html = `同時に複数のインポートをすることはできません`
      }

      if (html === '') {
        return config.import.run.none
      }

      this.$swal({
        icon: 'error',
        html: html,
      })
      this.isImported = false //ダイアログを閉じる
      this.$refs.usersImport.value = null
      this.$refs.groupsImport.value = null
      this.$refs.relationsImport.value = null
      return doc.data().import.run
    }
  }
}
</script>

<style scoped>
.user-settings {
  width: auto;
  height: calc(100% - 45px);
  user-select: none;
  padding-left: 35px;
  overflow: auto;
}
.title{
  width: 90%;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  margin: 20px 0 10px 0;
  padding: 0 0 5px 5px;
  color: #777;
  border-bottom: 1px solid #777;
}
.announce {
  width: auto;
  color: #f44336;
  font-size: 0.8em;
  margin: 5px 0 0 0;
}
.contents {
  min-width: 550px;
}
.content {
  margin: 0 0 20px 0;
}
.content-title {
  color: #777;
  font-size: 0.8em;
  margin: 0 0 10px 0;
}
.export-btn,
.import-btn {
  padding: 6px 18px;
  font-size: 0.8em;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 0px;
  background-color: #e6f4fd;
  color: #0e7bc6;
  margin: 0 0 0 10px
}
.export-btn:hover,
.import-btn:hover {
  background-color: #0e7bc6;
  color:  #e6f4fd;
}
input[type='file'] {
  position: relative;
  width: 400px;
  height: 70px;
  margin: 10px;
  box-sizing: border-box;
  border: 3px solid #0e7bc6;;
}
input[type='file']::before {
  content: 'ドラッグアンドドロップでインポート';
  font-size: 1.1em;
  color: #0e7bc6;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e6f4fd;
  cursor: pointer;
}
input[type='file']:focus {
  outline: none;
}
.successText {
  color: #777;
  font-size:0.7em
}
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 1000;
  user-select: text;
}
.panel {
  width: 1200px;
  max-width: calc(100% - 20px);
  height: 682px;
  max-height: 100%;
  background: #fff;
  position: fixed;
  right: 50%;
  bottom: 50%;
  transform: translate(50%,50%);
  overflow-y: hidden;
  overflow-x: auto;
}
.header {
  height: 40px;
  width: 100%;
  min-width: 900px;
  background: #0E7BC6;
  color: #fff;
  position: sticky;
  font-size: 0.9em;
}
.menu {
  position: absolute;
  right: 1.5%;
  top: 50%;
  transform: translate(0%, -50%);
  font-weight: lighter;
}
.menu-label {
  display: inline-block;
  line-height: 1.428571429;
  vertical-align: middle;
  cursor: pointer;
}
.material-icons {
  color: #fff;
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  display: inline-flex;
  vertical-align: middle;
  cursor: pointer;
}
.item {
  width: 100%;
  min-width: 900px;
  height: 40px;
  background: #fff;
  font-size: 0.7em;
  font-weight: bold;
  z-index: 600;
  display: flex;
  position: sticky;
}
.import-data {
  width: 100%;
  min-width: 900px;
  height: calc(100% - 120px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.item-content {
  align-items: center;
  font-size: 1.2em;
  height: 40px;
  display: flex;
}
.data-content {
  font-size: 0.9em;
  display: flex;
  align-items: center;
}
.data {
  width: 100%;
  min-width: 900px;
  height: 32px;
  display: flex;
  background: #fff;
  font-size: 0.75em;
  color: #333;
  border-bottom: 1px dashed #ccc;
}
.data:nth-child(1) {
  border-top: 1px dashed #ccc;
}
.data:hover {
  background: #e8f0fe;
}
.change {
  color: #f44336;
}
.number {
  width: 5%;
  justify-content: center;
}
.status {
  width: 5%;
  justify-content: center;
}
.id {
  width: 25%;
  padding-left: 10px;
}
.mail {
  width: 35%;
  padding-left: 10px;
}
.name {
  width: 20%;
  padding-left: 10px;
}
.priority {
  width: 10%;
  justify-content: center;
}
.small {
  width: 10%;
  justify-content: center;
}
.error-index {
  width: 5%;
  justify-content: center;
}
.error-contents {
  width: 100%;
  padding-left: 10px;
}
.scroll {
  min-width: 10px;
  max-width: 10px;
}
.footer {
  height: 40px;
  width: 100%;
  min-width: 900px;
  position: sticky;
  bottom: 0;
  font-size: 0.9em;
  background: #fff;
}
.save-sort {
  background-color: #cc0000;
  color: #ffffff;
  position: absolute;
  right: 1.5%;
  top: 50%;
  transform: translate(0%, -50%);
}
button {
  height: 30px;
  display: inline-block;
  padding: 0px 14px;
  font-size: 0.8em;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 3px;
}
button:focus {
  outline: none;
}
button:hover {
  background-color: #cc0000;
  opacity: 0.8;
}
/* ====== チェックボックス ====== */
.switchArea {
  position: relative;
  width: 40px;
  background: #fff;
}
.switchArea input[type="checkbox"] {
  display: none;
}
.switchArea label {
  display: block;
  box-sizing: border-box;
  height: 20px;
  border: 2px solid #999999;
  border-radius: 30px;
}
.switchArea input[type="checkbox"]:checked +label {
  border-color: #78bd78;
}
.switchArea #swImg {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #999999;
  top: 4px;
  left: 4px;
  border-radius: 26px;
  transition: .2s;
}
.switchArea input[type="checkbox"]:checked ~ #swImg {
  transform: translateX(20px);
  background: #78bd78;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Settings/Organization.vue